import { FC } from 'react';
import { CommonActiveDataSource } from '../common';
import { OverviewTabProps } from '../types/types';

export const ActiveCrmDataSource: FC<OverviewTabProps> = ({ dataSource }) => {
  return dataSource ? <CommonActiveDataSource dataSource={dataSource} polling={false} /> : <div />;
};
